'use strict';
import React, { PureComponent } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import UltimoCierre from './UltimoCierre.jsx';
import PagosRegistrados from './PagosRegistrados.jsx';
import Resumenes from './Resumenes.jsx';

class SaldosResumenesLimites extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { proximoResumen, resumenAnterior, pagos, ultimoCierre, cuenta, fechasCierres, saldosCierre,
            consumos, cuotas, ajustes, saldosTotales, fechasCierreUltimaCartera, detalleCuenta,
            pagosRegistradosPesos, pagosRegistradosDolares} = this.props.saldosResumenes;

        return <div className="container-fluid">
            <UltimoCierre saldosCierre={saldosCierre}
                proximoResumen={proximoResumen}
                ultimoCierre={ultimoCierre} />
            <PagosRegistrados pagos={pagos}
                proximoResumen={proximoResumen}
                fechasCierreUltimaCartera={fechasCierreUltimaCartera}
                detalleCuenta={detalleCuenta}
                pagosRegistradosPesos={pagosRegistradosPesos}
                pagosRegistradosDolares={pagosRegistradosDolares} />
            <Resumenes proximoResumen={proximoResumen}
                resumenAnterior={resumenAnterior} />
        </div>
    }
}
export default SaldosResumenesLimites;